/**
 * The server's own wording of a failed request, or '' when it gave none.
 *
 * fetchWrapper rejects with `{ status, statusText, message }`, where `message`
 * is the response body when there was one and the English `statusText`
 * otherwise, so a bare "Internal Server Error" is a fallback, not wording. A
 * network failure (a `TypeError` from fetch, no `status`) is the browser's
 * English and is never shown either. Callers fall back to a catalog message.
 * @param {unknown} err
 * @returns {string}
 */
export const serverMessage = (err) => {
  const message = typeof err?.message === 'string' ? err.message.trim() : '';
  if (!message || !err?.status || message === err.statusText) return '';
  return message;
};
